import { createAction } from 'typesafe-actions';

export const updateInitialRoute = createAction('UPDATE_INITIAL_ROUTE')<string>();

export const resetInitialRoute = createAction('RESET_INITIAL_ROUTE')<void>();
